import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDelete, doDownload, doPostFiles } from './utils'

// const API_ROOT = 'http://localhost:9004/api'

//หน้าหลัก ขยายระยะเวลา
export const contractExtendPeriodPage = (projectVersionId) => {
  const url = `${API_ROOT}/contract/extend-period/${projectVersionId}/get`
  return doGet(url)
}
//ประวัติ ขยายระยะเวลา
export const contractExtendPeriodHistory = (projectVersionId) => {
  const url = `${API_ROOT}/contract/extend-period/${projectVersionId}/history`
  return doGet(url)
}

//แสดงคำขอขยายระยะเวลา
export const contractExtendPeriodForm = (projectVersionId, id) => {
  const url = `${API_ROOT}/contract/extend-period/${projectVersionId}/get-form?id=${id || ''}`
  return doGet(url)
}

//สร้างคำขอขยายระยะเวลา
export const contractExtendPeriodCreate = (projectVersionId) => {
  const url = `${API_ROOT}/contract/extend-period/${projectVersionId}/create`
  return doPost(url)
}

//บันทึกร่าง-ส่งขอขยายระยะเวลา
export const contractExtendPeriodSave = (req) => {
  const url = `${API_ROOT}/contract/extend-period/save`
  return doPostFiles(url, req)
}

//ลบคำขอขยายระยะเวลา
export const contractExtendPeriodCancel = (req) => {
  const url = `${API_ROOT}/contract/extend-period/cancel`
  return doPost(url, req)
}

//ส่งเสนอพิจารณาขอขยายระยะเวลา (นวก.)
export const contractExtendPeriodRequestApprove = (req) => {
  const url = `${API_ROOT}/contract/extend-period/request-approve`
  return doPost(url, req)
}

//ไม่อนุมัติขอขยายระยะเวลา (ผู้มีอำนาจอนัม้ติ)
export const contractExtendPeriodNotApprove = (req) => {
  const url = `${API_ROOT}/contract/extend-period/not-approve`
  return doPost(url, req)
}
